import i18n from "i18n";

export const pageMessages = {
  updatePage: i18n.t('notifications.common.update', { dataType: i18n.t('labels.page') }),
  deletePage: i18n.t('notifications.common.delete', { dataType: i18n.t('labels.page') }),

  rotatePage: i18n.t('notifications.page.rotatePage'),
  rotatePages: i18n.t('notifications.page.rotatePages'),

  updatePageTag: i18n.t('notifications.common.update', { dataType: i18n.t('labels.pageTag') }),
  updatePagesTag: i18n.t('notifications.common.updateMany', { dataType: i18n.t('labels.pagesTag') }),
  removePageTag: i18n.t('notifications.common.delete', { dataType: i18n.t('labels.pageTag') }),
  removePagesTag: i18n.t('notifications.common.deleteMany', { dataType: i18n.t('labels.pagesTag') }),

  updatePageColor: i18n.t('notifications.common.update', { dataType: i18n.t('labels.pageColors') }),
  updatePagesColor: i18n.t('notifications.common.updateMany', { dataType: i18n.t('labels.pagesColors') }),
  removePageColor: i18n.t('notifications.common.delete', { dataType: i18n.t('labels.pageColors') }),
  removePagesColor: i18n.t('notifications.common.deleteMany', { dataType: i18n.t('labels.pagesColors') }),

  addPageToWorkspace: i18n.t('notifications.page.addPageToWorkspace'),
  addPagesToWorkspace: i18n.t('notifications.page.addPagesToWorkspace'),
  removePageFromWorkspace: i18n.t('notifications.page.removePageFromWorkspace'),
  removePagesFromWorkspace: i18n.t('notifications.page.removePagesFromWorkspace'),

  addHighlightToPage: i18n.t('notifications.page.addHighlightToPage'),
  deleteHighlightFromPage: i18n.t('notifications.page.deleteHighlightFromPage'),

  removePageFromStaple: i18n.t('notifications.page.removePageFromStaple'),

  exportPagesToPDF: i18n.t('notifications.page.exportPagesToPDF'),

  createStaple: i18n.t('notifications.common.create', { dataType: i18n.t('labels.staple') }),
  updateStaple: i18n.t('notifications.common.update', { dataType: i18n.t('labels.staple') }),
  removeStaple: i18n.t('notifications.common.delete', { dataType: i18n.t('labels.staple') })
};

i18n.on('languageChanged', () => {
  pageMessages.updatePage = i18n.t('notifications.common.update', { dataType: i18n.t('labels.page') });
  pageMessages.deletePage = i18n.t('notifications.common.delete', { dataType: i18n.t('labels.page') });
  pageMessages.rotatePage = i18n.t('notifications.page.rotatePage');
  pageMessages.updatePageTag = i18n.t('notifications.common.update', { dataType: i18n.t('labels.pageTag') });
  pageMessages.removePageTag = i18n.t('notifications.common.delete', { dataType: i18n.t('labels.pageTag') });
  pageMessages.updatePageColor = i18n.t('notifications.common.update', { dataType: i18n.t('labels.pageColors') });
  pageMessages.removePageColor = i18n.t('notifications.common.delete', { dataType: i18n.t('labels.pageColors') });
  pageMessages.addPageToWorkspace = i18n.t('notifications.page.addPageToWorkspace');
  pageMessages.removePageFromWorkspace = i18n.t('notifications.page.removePageFromWorkspace');
  pageMessages.addHighlightToPage = i18n.t('notifications.page.addHighlightToPage');
  pageMessages.deleteHighlightFromPage = i18n.t('notifications.page.deleteHighlightFromPage');
  pageMessages.removePageFromStaple = i18n.t('notifications.page.removePageFromStaple');
  pageMessages.exportPagesToPDF = i18n.t('notifications.page.exportPagesToPDF');
  pageMessages.createStaple = i18n.t('notifications.common.create', { dataType: i18n.t('labels.staple') });
  pageMessages.updateStaple = i18n.t('notifications.common.update', { dataType: i18n.t('labels.staple') });
  pageMessages.removeStaple = i18n.t('notifications.common.delete', { dataType: i18n.t('labels.staple') });
})
